import { render } from "./avatar-upload.vue?vue&type=template&id=23978c50"
import script from "./avatar-upload.vue?vue&type=script&lang=js"
export * from "./avatar-upload.vue?vue&type=script&lang=js"

import exportComponent from "/builds/univerza-maribor/brium/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__